import { ReactElement } from "react";
import { Stack, StackProps, SvgIconProps } from "@mui/material";
import { IconHidden } from "src/components/icons-mui/hidden";
import { Typography, TypographyProps } from "src/components-mui/base/typography/typography";

const EMPTY_STATE_DESCRIPTION_TEST_ID = "empty-state-description";
const EMPTY_STATE_TITLE_TEST_ID = "empty-state-title";

export interface IEmptyStateProps extends StackProps {
    title: string;
    description?: string;
    iconSize?: SvgIconProps["fontSize"] | number | number[];
    CustomIcon?: ReactElement;
    descriptionProps?: TypographyProps;
    hideIcon?: boolean;
    px?: number[];
    pt?: number[];
    pb?: number[];
    mt?: number;
    p?: number;
    boxShadow?: number;
}

export const EmptyState = (props: IEmptyStateProps) => {
    const {
        title,
        description,
        iconSize = [80, 136],
        CustomIcon,
        descriptionProps = {},
        hideIcon = false,
        px = [2, 5],
        pt = [2, 5],
        pb = [3, 5],
        mt,
        p,
        boxShadow = 1,
        sx,
        ...stackProps
    } = props;

    return (
        <Stack
            direction="column"
            {...stackProps}
            sx={[
                {
                    alignItems: "center",
                    bgcolor: "white",
                    borderRadius: "8px",
                    boxShadow,
                    px,
                    pt,
                    pb,
                    mt,
                    p,
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {!hideIcon && (CustomIcon ?? <IconHidden sx={{ fontSize: iconSize }} />)}
            <Typography
                data-test-id={EMPTY_STATE_TITLE_TEST_ID}
                sx={{ fontSize: "xl", fontWeight: "bold", textAlign: "center", mt: hideIcon ? 0 : [2, 3] }}
            >
                {title}
            </Typography>
            {description && (
                <Typography data-test-id={EMPTY_STATE_DESCRIPTION_TEST_ID} {...descriptionProps} sx={{ textAlign: "center", mt: 2 }}>
                    {description}
                </Typography>
            )}
        </Stack>
    );
};
